export default __webpack_public_path__ + "static/media/insurance.e29d389f.svg";